// extracted by mini-css-extract-plugin
module.exports = {"mediumScreen":"720px","smallScreen":"540px","xmediumScreen":"850px","xlargeScreen":"1280px"};